<template>
  <div
    class="wrapper"
    @click="closeMediaItemPreviewModal"
  >
    <button
      class="close_modal_btn"
      @click="closeMediaItemPreviewModal"
    >
      <svg-vue icon="icons/modal_cross" />
    </button>
    <div
      class="media_item_preview"
      @click.stop=""
    >
      <img :src="mediaItemPreviewSource">
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('businessProfile', [
      'mediaItemPreviewModalOpen',
      'mediaItemPreviewSource',
    ]),
  },
  methods: {
    ...mapActions('businessProfile', [
      'closeMediaItemPreviewModal',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);

  .close_modal_btn {
    position: fixed;
    top: 0;
    right: 0;
    padding: 1rem;
    cursor: pointer;

    :deep(svg) {
      height: 32px;
      width: 32px;

      path {
        stroke: white;
      }
    }
  }

  .media_item_preview {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-height: 80vh;
      max-width: 90vw;
    }
  }
}
</style>
